import { render, staticRenderFns } from "./CartTemplate.vue?vue&type=template&id=242e7f12"
import script from "./CartTemplate.vue?vue&type=script&lang=js"
export * from "./CartTemplate.vue?vue&type=script&lang=js"
import style0 from "./CartTemplate.vue?vue&type=style&index=0&id=242e7f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports